import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { formatArea, formatEOFound, formatPeriod, ValidationStatusComponent } from 'utils/Helper';
import { Table, TableHeader, TableRow } from 'component/Table';
import { ReportActions } from '../ReportActions';
import { WEEKLY_HEADERS } from 'consts/ReportHeaders';
import { ReactComponent as SortByIcon } from 'assets/images/icons/Sort-by2.svg';
import { InteractiveValidationStatus } from 'component/InteractiveValidationStatus';
import CreateReportPopup from '../Components/CreateReportPopup';

export const WeeklyTable = ({
  reports,
  setLoader,
  setReportsPageList,
  onLoadMore,
  hasMore,
  onSort,
  currentPage,
  onPageChange,
  onCreateReport
}) => {

  const handleStatusChange = (reportId, newStatus) => {
    setReportsPageList(prevList => ({
      ...prevList,
      results: prevList.results.map(item =>
        item.id === reportId
          ? {
              ...item,
              validation_status: newStatus,
              status_manually_changed: true
            }
          : item
      )
    }));
  };
  const [rotations, setRotations] = useState({});
  const [sortDirection, setSortDirection] = useState({});
  const [lastClickedIcon, setLastClickedIcon] = useState(null);

  const handleSortIconClick = async (key) => {
    try {
      setLoader(true);
      setReportsPageList([]);
      onPageChange(1);

      const currentDirection = sortDirection[key] || false;
      const newDirection = !currentDirection;
      setSortDirection(prev => ({
        ...prev,
        [key]: newDirection,
      }));

      const ordering = newDirection ? key : `-${key}`;
      await onSort(ordering);

      const currentRotation = rotations[key] || 0;
      const newRotation = currentRotation + 180;

      if (lastClickedIcon && lastClickedIcon !== key) {
        setRotations(prevRotations => ({
          ...prevRotations,
          [lastClickedIcon]: 0,
        }));
      }

      setRotations(prevRotations => ({
        ...prevRotations,
        [key]: newRotation,
      }));

      setLastClickedIcon(key);
    } catch (error) {
      console.error('Error during sorting:', error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="eore-table">
      <Table>
        <TableHeader>
          {WEEKLY_HEADERS?.map((header, index) => (
            <th
              key={index}
              className={`text-with-icon ${header.style ? '' : ''}`}
              style={header.style || {}}
            >
              {header.key && header.condition && (
                <SortByIcon
                  className="sort-icon"
                  style={{ transform: `rotate(${rotations[header.key] || 0}deg)` }}
                  onClick={() => handleSortIconClick(header.key)}
                />
              )}
              {header.label}
            </th>
          ))}
        </TableHeader>
        <tbody>
          {reports?.length === 0 && (
            <TableRow>
              <td>Дані відсутні</td>
            </TableRow>
          )}
          {reports?.map((item) => (
            <TableRow key={item?.id}>
              <td>{item?.created_at ? new Date(item?.created_at)?.toLocaleDateString('uk-UA', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
              }) : '-'}</td>
              <td>{item?.internal_id || '-'}</td>
              <td>{formatPeriod(item?.period)}</td>
              <td>{item?.type || '-'}</td>
              <td>{formatArea(item?.area, item?.cleared_area)}</td>
              <td style={{ textAlign: 'start' }}>{formatEOFound(item?.eo_found)}</td>
              <td>
                <InteractiveValidationStatus
                  reportType="weekly"
                  reportId={item?.id}
                  currentStatus={{
                    ...item?.validation_status,
                    status_manually_changed: item?.status_manually_changed
                  }}
                  onStatusChange={handleStatusChange}
                />
              </td>
              <td aria-label="actions">
                <ReportActions
                  reportId={item?.id}
                  clearanceId={item?.clearance_task_id}
                  setLoader={setLoader}
                  setReportsPageList={setReportsPageList}
                  validationStatus={item?.validation_status?.value}
                  isCurrentValidationRole={item?.is_current_validation_role}
                  mode="weeklyTab"
                />
              </td>
            </TableRow>
          ))}
          {hasMore && (
            <div className="loadMore-div">
              <button
                className="loadMore-button"
                onClick={onLoadMore}
              >
                Load more...
              </button>
            </div>
          )}
          <div className="drone-footer">
            <CreateReportPopup
              type="weekly"
              onCreateReport={onCreateReport}
              menuPortalTarget={document.body}
              customStyles={{
                menu: (provided) => ({
                  ...provided,
                  position: 'absolute',
                  zIndex: 9999,
                  width: '100%',
                  top: '100%',
                  left: 0
                }),
                menuPortal: (provided) => ({
                  ...provided,
                  zIndex: 9999
                }),
                control: (provided) => ({
                  ...provided,
                  position: 'relative'
                }),
                container: (provided) => ({
                  ...provided,
                  position: 'relative'
                })
              }}
            />
          </div>
        </tbody>
      </Table>
    </div>
  );
};

const WeeklyTab = ({
  setLoader,
  weeklyList,
  setWeeklyList,
  currentPage,
  onPageChange,
  onFetch
}) => {
  const [sortParams, setSortParams] = useState('');

  const handleSort = (ordering) => {
    onPageChange(1);
    setSortParams(ordering);
    setLoader(true);
    return onFetch(1, ordering)
      .finally(() => {
        setLoader(false);
      });
  };

  const handleLoadMore = () => {
    const nextPage = currentPage + 1;
    onPageChange(nextPage);
    setLoader(true);
    onFetch(nextPage, sortParams)
    .finally(() => {
      setLoader(false);
    });
  };

        const handleCreateWeekly = async (reportData) => {
    if (reportData.dailyReportIds) {
      try {
        setLoader(true);
        const response = await axios.post('/reports/clearance/weekly/', {
          daily_report_ids: reportData.dailyReportIds
        });

        toast.success('Weekly report created successfully');

        onFetch(1, sortParams);

        return true;

            } catch (error) {
        console.error('Error creating weekly report:', error);

        if (error.request?.responseText) {
          try {
            const errorJson = JSON.parse(error.request.responseText);
            if (errorJson.message) {
              toast.error(errorJson.message);
            } else if (typeof errorJson === 'string') {
              toast.error(errorJson);
            } else {
              toast.error(error.request.responseText);
            }
          } catch (parseError) {
            const cleanMessage = error.request.responseText
              .replace(/^["'\[\]]+|["'\[\]]+$/g, '')
              .replace(/\\"/g, '"')
              .trim();
            toast.error(cleanMessage);
          }
        } else if (error.response?.data) {

          const errorData = error.response.data;
          if (typeof errorData === 'string') {
            toast.error(errorData);
          } else if (errorData.detail) {
            toast.error(errorData.detail);
          } else if (errorData.daily_report_ids) {
            toast.error(errorData.daily_report_ids[0] || 'Invalid daily report selection');
          } else {
            toast.error('Error creating weekly report');
          }
        } else {
          toast.error('Error creating weekly report');
        }
        return false;
      } finally {
        setLoader(false);
      }
    } else {
      toast.warning('Please select daily reports for weekly creation');
      return false;
    }
  };

    return (
    <WeeklyTable
      reports={weeklyList?.results || []}
      hasMore={!!weeklyList?.next}
      onLoadMore={handleLoadMore}
      setLoader={setLoader}
      setReportsPageList={setWeeklyList}
      onSort={handleSort}
      currentPage={currentPage}
      onPageChange={onPageChange}
      onCreateReport={handleCreateWeekly}
    />
  );
};

export default WeeklyTab;